module.exports = __webpack_public_path__ + "static/media/banorte-logo.62336c14.svg";